import { createContext, useContext } from 'react';

/**
 * Member ids in the order the unplaced pool lists them. A person dropped into the
 * pool mounts at that position, so the drop animation aims there. Empty when not
 * provided (stories): the animation then aims after the last avatar.
 */
export const TalentReviewMemberOrderContext = createContext<ReadonlyArray<string>>([]);

export const useTalentReviewMemberOrder = () => useContext(TalentReviewMemberOrderContext);
